// src/components/Caro.jsx
import { useRef, useEffect, useState } from "react";
import FsLightbox from "fslightbox-react";

export default function Caro({ slabs = [] }) {
  const sliderRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [galleryToggler, setGalleryToggler] = useState(false);
  const [gallerySlide, setGallerySlide] = useState(1);

  // Duplicate items if fewer than 2 for proper display
  const items = slabs.length < 2 ? [...slabs, ...slabs] : slabs;
  const loopItems = [...items, ...items]; // duplicate for seamless loop

  // Array of images for lightbox
  const galleryImages = items.map((item) => item.image);

  // Auto scroll effect
  useEffect(() => {
    if (!sliderRef.current) return;
    const slider = sliderRef.current;
    const step = 1; // scroll speed

    const interval = setInterval(() => {
      if (!isHovered) {
        slider.scrollLeft += step;

        // Seamless reset at halfway
        if (slider.scrollLeft >= slider.scrollWidth / 2) {
          slider.scrollLeft -= slider.scrollWidth / 2;
        }
      }
    }, 15);

    return () => clearInterval(interval);
  }, [isHovered, loopItems]);

  // Manual scroll with arrow buttons
  const scrollManual = (val) => {
    if (!sliderRef.current) return;
    const slider = sliderRef.current;
    slider.scrollLeft += val;

    // Loop manually if beyond first sequence
    if (slider.scrollLeft >= slider.scrollWidth / 2) {
      slider.scrollLeft -= slider.scrollWidth / 2;
    } else if (slider.scrollLeft < 0) {
      slider.scrollLeft += slider.scrollWidth / 2;
    }
  };

  // Open lightbox on image click
  const openLightbox = (index) => {
    setGallerySlide(index + 1); // FsLightbox is 1-based
    setGalleryToggler(!galleryToggler);
  };

  return (
    <>
      <div
        className="slider-wrapper"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          width: "100%",
          maxWidth: "100%",
          margin: "0 auto",
        }}
      >
        {/* <button
          className="arrow left"
          onClick={() => scrollManual(-sliderRef.current.offsetWidth / 2)}
          style={{ fontSize: "2rem", cursor: "pointer" }}
        >
          ‹
        </button> */}

        <div
          className="slider"
          ref={sliderRef}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            display: "flex",
            overflowX: "hidden",
            scrollBehavior: "smooth",
            gap: "16px",
            width: "100%",
          }}
        >
          {loopItems.map((item, i) => (
            <div
              className="card"
              key={i}
              style={{
                flex: "0 0 50%", // show 2 items at a time
                borderRadius: "12px",
                minWidth: "150px",
                textAlign: "center",
                cursor: "pointer",
              }}
              onClick={() => openLightbox(i % items.length)} // modulo to get correct image
            >
              <img
                src={item.image}
                alt={item.weight}
                style={{
                  width: "100%",
                  height: "260px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginBottom: "8px",
                }}
              />
            </div>
          ))}
        </div>

        {/* <button
          className="arrow right"
          onClick={() => scrollManual(sliderRef.current.offsetWidth / 2)}
          style={{ fontSize: "2rem", cursor: "pointer" }}
        >
          ›
        </button> */}
      </div>

      {/* FsLightbox */}
      <FsLightbox
        toggler={galleryToggler}
        slide={gallerySlide}
        sources={galleryImages}
      />
    </>
  );
}